import React, {useEffect, useState, useRef, useContext} from "react";
import * as Survey from "survey-react";
import "survey-react/survey.css";
import { surveyService } from "../../services";
import { Skeleton, Modal, Button, notification } from 'antd';
import { GlobalContext } from "../../contexts/GlobalContext";
import { config } from "../../config";
//import useWindowDimensions from "../../hooks/useWindowDimensions";
import "../SurveyViewer/SurveyViewer.css";
import { UserContext } from "../../contexts/UserContext";
import { ConsoleView } from "react-device-detect";

const SurveyVerification= ({onClose,id,details,idcontrols,editVerifiedSurvey,setShowVerificationInterface,bicycleParkingSpot,setShowBicycleParkingVisible,...otherProps}) => {
    const { location: userLocation } = useContext(UserContext)
    //const {width, height} = useWindowDimensions()
    const {successHandler, errorHandler, loading, setLoading } = useContext(GlobalContext)
    let model = null;
    const storageName = `ciklopark_saved_state_${4}`;
    const surveyModelRef = useRef(null);
    const [selectedSurvey, setSelectedSurvey] = useState(null)
    const [isSaving, setIsSaving] = useState(false)
    let [authorizationStatus,setAuthorizationStatus] =React.useState("0")

    let [surveyData, setSurveyData] = useState()
    let [visible, setVisible]=useState(false)
    let [nearbyBicycleParkingSpots,setNearbyBicycleParkingSpots]=useState()
    let [embedMapLink,setEmbedMapLink]=useState()
    const [parentPoint,setParentPoint]=useState();

    const getSurveyData = async () =>{
        let surveyData
        if (editVerifiedSurvey){
            surveyData={id,details,idcontrols}
        }
        else{
        surveyData= await surveyService.getSurveyData()
        }
        setVisible(false)
        
        if(surveyData[0]&&!editVerifiedSurvey){
            setSurveyData(surveyData[0])
            const point =await surveyService.getClosestPoints(surveyData[0]?.x,surveyData[0]?.y)
            let pointLabeled=null
            if(point){
                 pointLabeled = point?.map(d => ({id: d.id, geom: d.geom,photo: d?.photo||d?.photo_alternative_demand||d?.photo_existing_demand}))       
            }  
            setNearbyBicycleParkingSpots(pointLabeled)
        }
        else if(surveyData&&!editVerifiedSurvey) {
            setSurveyData(surveyData)
            const point=await surveyService.getClosestPoints(surveyData.x,surveyData.y)       
            let pointLabeled=null
            if(point){
                 pointLabeled = point?.map(d => ({id: d.id, geom: d.geom,photo: d?.photo||d?.photo_alternative_demand||d?.photo_existing_demand}))       
            }        
            setNearbyBicycleParkingSpots(pointLabeled)
        }
        else{
            setSurveyData(surveyData)
        }

        setVisible(true)
    }

    React.useEffect(() => {
        const fetchData = async () => {
        await Promise.all([getSurveyData()]);
        }
    
        fetchData();
    }, [])

    const loadSelection = (survey) => {
        let storageSt = window
            .localStorage
            .getItem(storageName) || "";

        let res = {};
        if (storageSt) {
            res = JSON.parse(storageSt);
        }
    }

    const loadState = (survey) => {
        let storageSt ={data:surveyData.details}
        let res = {};
        if (storageSt) {
            res = storageSt;
            if(survey) {
                //Set the loaded data into the survey.
                if (res.currentPageNo) {
                    survey.currentPageNo = res.currentPageNo;
                }
                    
                if (res.data) {
                    survey.data = res.data;
                    //survey.runTriggers();
                } 
            }
        }
    }

    const saveState = (survey) => {
        if(!survey) {
            
            return;
        }

        const res = {
            currentPageNo: survey.currentPageNo,
            data: survey.data
        };

        window
            .localStorage
            .setItem(storageName, JSON.stringify(res));
            
    }

     const clickedDeny=()=>{
        if(parentPoint){
            authorizationStatus="4"
        }
        else{
            authorizationStatus="2"
        }
        finishSurvey()
    }

     const clickedAccept=()=>{
        if(parentPoint){
            authorizationStatus="4"
        }
        else{
            authorizationStatus="1"
        }
        finishSurvey()
    }


    useEffect(() => {
        
        const fetchData = async () => {
            setLoading(true)
            try {
                if(!surveyData){
                    console.log("No data to show")
                }
                else{
                    if(!editVerifiedSurvey){
                        setEmbedMapLink(`https://www.openstreetmap.org/export/embed.html?bbox=${surveyData.y}%2C${surveyData.x}%2C${surveyData.y}%2C${surveyData.x}&amp;layer=mapnik&amp;marker=${surveyData.y}%2C${surveyData.x}&amp;zoom=12`)
                
                    }
                const response = await surveyService.getSurvey(surveyData.idcontrols)
                const survey = response?.length && response[0].title
                if(survey) {
                    survey.completeText = "Završi anketu";
                    setSelectedSurvey(survey)
                    if(selectedSurvey) {
                        model = new Survey.Model(selectedSurvey);
                        loadState(model)
                
                        model.onCurrentPageChanged
                            .add((survey, options) => {
                                saveState(survey);
                            });

                        
                       
                        surveyModelRef.current = model;
                
                        /*
                        clearInterval(timerId)
                        timerId = window.setInterval(function () {
                            saveState(model);
                        }, 15000);
                        */
                    }
                    loadSelection(model)
                }
            }
            }
            catch(error) {               
                    console.error("Error while loading survey:", error?.response)
                    errorHandler("Pogreška prilikom učitavanja ekrana")   
                
            }
            finally {
               setLoading(false)
            }
        }

        if(visible ) {
            fetchData()
        }

    }, [visible])

    if(selectedSurvey) {
        model = new Survey.Model(selectedSurvey);
        loadState(model)

        model.onCurrentPageChanged
        .add((survey, options) => {
            saveState(survey);
        });

        model.onAfterRenderQuestion
        .add(function (sender, options) {
            if(options.question.getType() === "file") {
                let cameraFunction = options.htmlElement.querySelector("input");
                let cameraIcon = options.htmlElement.querySelector(".sv_q_file_choose_button");
                let removePlaceholderText = options.htmlElement.querySelector(".sv_q_file_placeholder");                
                cameraFunction.capture = "camera";
                cameraIcon.innerHTML="<li class='fa enlargePhotoIcon' >&#xf030;</li>"
          
            }
        });
       
       
        surveyModelRef.current = model;

        /*
        clearInterval(timerId)
        timerId = window.setInterval(function () {
            saveState(model);
        }, 15000);
        */
    }



 
    
    //Survey.FunctionFactory.Instance.register("getMunicipalityCityFromCounty", getMunicipalityCityFromCounty);
    Survey.locale = "hr";

    const handleComplete = async (survey, options) => {
        //console.log("Got answers:", survey.data, options)
        setIsSaving(true)
        if(parentPoint){
            try {
                await surveyService.setParentSurvey({
                    id:surveyData.id,
                    status:"4",
                    parentID:parentPoint,
                    idupdated:"4"
                    
                })
                window.localStorage.removeItem(storageName);
                successHandler("Uspješno je updatiran nad tocka")
                onClose()
                
               
            }
            catch(error) {
                if(!userLocation){}
                else{
                    
                console.error("Error while saving response:", error)
                errorHandler("Dogodila se pogreška, pokušajte ponovno")
                }
            }
            finally {
                setIsSaving(false)
                setVisible(false)
                getSurveyData()
            }
        }
        
        try {
            if(surveyData.idcontrols!=1&& surveyData.idcontrols!=6){
                await surveyService.updateSurveyData({
                    id:surveyData.id,
                    details: JSON.stringify(survey.data),
                    status:authorizationStatus
                })
            }
            else{
                await surveyService.updateSurveyData({
                    id:surveyData.id,
                    status:authorizationStatus
                })

            }
            
        
            window.localStorage.removeItem(storageName);
            successHandler("Uspješno ste verificirali anketu")
            onClose()
            
           
        }
        catch(error) {
            if(!userLocation){}
            else{
                
            console.error("Error while saving response:", error)
            errorHandler("Dogodila se pogreška, pokušajte ponovno")
            }
        }
        finally {
            setIsSaving(false)
            setVisible(false)
            getSurveyData()
            if(editVerifiedSurvey){
                setShowBicycleParkingVisible(false)
                setShowVerificationInterface(false)  
                otherProps.onDataUpdate()                
            }
        }
    }

    const finishSurvey = () => {
        //console.log("Got user location:", userLocation, config.getUser())
       
        if(!loading && !selectedSurvey) {
           onclose()
            return
        }
        const survey = surveyModelRef?.current
        if(survey) {
            survey.completeLastPage()
        }
        
    }

    

return(
    <>
       
       {loading && <Skeleton active />}
       {!surveyData&& (
       <><p>Trenutno nema novih anketa za prikazati</p>
       <Button onClick={getSurveyData}>Učitaj ponovno</Button>
       
       
       </>) ||
        (<>
        <div className="verificationRow">
        

        <div className="verificationSurveyColumn">
        <h1>{surveyData&&surveyData.id}</h1>
        {surveyData&&<embed class="map" width='600px' height='400px'src={embedMapLink} onerror="alert('URL invalid !!');"></embed>}
            {!loading && selectedSurvey && (
                <Survey.Survey className="authorizationModal" model={model} locale="hr"  onComplete={handleComplete} />
            )}
            {!loading && !selectedSurvey && (
                <div>Greška prilikom dohvata podataka</div>
            )}
           
             <div className="survey-viewer__footer">
                <Button key="deny" className="authorization-btn deny-btn" disabled={loading}  loading={isSaving} onClick={clickedDeny}>
                    {!loading && !selectedSurvey && "Zatvori" || 'Odbij'}
                </Button>
                <Button key="agree" className="authorization-btn accept-btn" disabled={loading}  loading={isSaving} onClick={clickedAccept}>
                    {!loading && !selectedSurvey && "Zatvori" || 'Prihvati'}
                </Button>
             </div>
             </div>  



              { surveyData.idcontrols!=1&& surveyData.idcontrols!=6&&<div className="verificationImageColumn">
        <div className="verificationImageColumnAlwaysOnTop">
        {surveyData&&(<img className="center-survey__image" src={`${config.url}${surveyData.details?.photo|| surveyData.details?.photo_alternative_demand||surveyData.details?.photo_existing_demand }`}></img>)}
        <label>
            <input className="verificationRadioButtonNonChoice" type="radio" value="" name="Point" onChange={e=>setParentPoint(e.target.value)}/> 
            <img className="verificationNonChoice" width="100px" height="100px"></img>
        </label>
        {nearbyBicycleParkingSpots?.map((id)=>
        <label>
            <input className="verificationRadioButton" type="radio" value={id.id} name="Point"  onChange={e=>setParentPoint(e.target.value)}/> 
            <img className="verificationImage" src={`${config.url}${id.photo}`} width="100px" height="100px"></img>
        </label>
        )}
       
        
        </div>
        </div>}



             </div>
             </>)}
                
            
        
    </>
)


}
export default SurveyVerification;